export const APILIST = {
    CREATE_LEAD:"/api/lead/create",
    GET_LEAD_CLIENT:"/api/lead/get-all",
    GET_LEADER_BOARD:"/api/lead/leader-board",
    GET_USER:"/api/user/get",
    GET_VERIFY_LEAD:"/api/lead/verified-lead-popup",
    GET_BADGE_LEADER_BOARD:"/api/lead/get-badges"
}
export default APILIST
